import { $http } from "@/utils/https";
import type { ActionContext } from "vuex";
import type { RootState } from "@/store";

interface State {
  guides: any;
}

const state: State = {
  guides: null,
};

const getters = {
  content: (state: State) => state.guides,
};

const actions = {
  FETCH_GUIDES_PAGE: async ({ commit }: ActionContext<State, RootState>) => {
    try {
      const response = await $http.get("v1/pages/guides");
      commit("SET_GUIDES_PAGE_DATA", response.data.data);
      return response.data.data;
    } catch (e) {
      throw e;
    }
  },
  SEND_DOWNLOAD_EVENT: async ({ commit }: ActionContext<State, RootState>, payload: any) => {
    try {
      const response = await $http.post("v1/increment_count", payload);
      return response.data.data;
    } catch (e) {
      console.log(e);
    }
  }
};

const mutations = {
  SET_GUIDES_PAGE_DATA(state: State, products: any) {
    state.guides = products;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
